import React from 'react';
import { HardHat, Loader2 } from 'lucide-react';

// Riquadro in Documenti: quanti verbali DPI sono da creare e da firmare
export const VerbaliDpiCard = ({ dati, onApri }) => {
  if (!dati || dati.errore_rete) return null;
  const c = dati.conta || {};
  const riga = !dati.dvr ? 'Carica il DVR: dati della società e DPI si prendono da lì.'
    : dati.in_corso ? null
      : `${c.da_creare || 0} da creare · ${c.da_firmare || 0} da firmare · ${c.firmato || 0} firmati`;
  return (
    <div className="rounded-2xl border border-orange-200 bg-orange-50 p-4 space-y-2" data-testid="dpi-card">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-orange-500 flex items-center justify-center shrink-0"><HardHat className="h-5 w-5 text-white" /></div>
        <div className="min-w-0 flex-1">
          <p className="font-bold text-gray-900">Verbali di consegna DPI</p>
          {riga ? <p className="text-xs text-gray-600" data-testid="dpi-card-conta">{riga}</p>
            : <p className="text-xs text-gray-600 flex items-center gap-1.5" data-testid="dpi-card-lettura"><Loader2 className="h-3.5 w-3.5 animate-spin" />Leggo DVR e attestati...</p>}
        </div>
      </div>
      <button onClick={onApri} data-testid="dpi-apri-btn" className="w-full h-11 rounded-full bg-gray-900 text-white text-sm font-semibold flex items-center justify-center gap-2">
        <HardHat className="h-4 w-4" />Prepara e firma i verbali
      </button>
    </div>
  );
};
